
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 14.667c-.366 0-.68-.13-.941-.392A1.284 1.284 0 012 13.333V4c0-.367.13-.68.392-.942.26-.26.575-.391.941-.391h5.334V4H3.333v9.333h9.334v-4H14v4c0 .367-.13.68-.392.942a1.284 1.284 0 01-.941.392H3.333zM4.667 12H6V7.333H4.667V12zm2.666 0h1.334V5.333H7.333V12zM10 12h1.333V9.333H10V12z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.794 4.633c-.743-.196-.982-.4-.982-.716 0-.364.33-.617.884-.617.583 0 .8.283.819.7h.723c-.022-.573-.366-1.1-1.05-1.27V2h-.983v.72c-.635.14-1.146.56-1.146 1.203 0 .77.625 1.154 1.539 1.377.818.2.982.493.982.803 0 .23-.16.597-.884.597-.674 0-.94-.307-.976-.7H10c.04.73.576 1.14 1.205 1.277V8h.982v-.717c.639-.123 1.146-.5 1.146-1.183 0-.947-.795-1.27-1.539-1.467z","fill":"currentColor"}})])
          )
        }
      }
    